import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CityModel, HxCityService, HxUiLabelPipe } from 'hx-services';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { NgFor } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-city-select',
    templateUrl: './city-select.component.html',
    styleUrls: ['./city-select.component.css'],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HxCitySelectComponent),
      multi: true
    }],
  imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, TranslocoPipe, HxUiLabelPipe]
})
export class HxCitySelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() multiple = false;
  /** Auto-select the single available option — true = existing behaviour everywhere. Set false when
   * the caller's selection must never be filled in silently (e.g. it narrows a drill-down list). */
  @Input() default = true;
  @Input() all = true;
  @Input() countryId?: number;
  @Input() cityIds?: number[];
  @Output() selectChange = new EventEmitter<CityModel | CityModel[] | undefined>();

  disabled = false;
  options: CityModel[] = [];
  selected: number | number[] | undefined;

  constructor(
    private cityService: HxCityService,
  ) {
  }

  ngOnInit(): void {
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryId']) {
      this.getOptions();
    } else if (changes['storeIds']) {
      this.getOptions();
    }
  }

  onModelChanged(val: any) {
    this.onChange(val);
    if (!this.multiple) {
      if (this.selected) {
        this.selectChange.emit(this.options.find(p => p.id === this.selected));
      } else {
        this.selectChange.emit();
      }
    } else {
      if (Array.isArray(this.selected)) {
        const ids: number[] = this.selected;
        this.selectChange.emit(this.options.filter(p => ids.includes(p.id)));
      } else {
        this.selectChange.emit([]);
      }
    }
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj?: number | number[]): void {
    this.selected = obj;
  }

  private getOptions() {
    if (this.all) {
      this.cityService.getAllCities({ limit: 1000, countryId: this.countryId }).then(cities => {
        this.options = cities;
        if (this.cityIds && this.cityIds.length) {
          this.options = this.options.filter(r => this.cityIds?.includes(r.id));
        }
        if (this.default && (this.options ?? []).length === 1) {
          this.selected = this.options[0].id;
          this.onModelChanged(this.selected);
        }
      });
    } else {
      this.cityService.getMyCities({ countryId: this.countryId }).subscribe(cities => {
        this.options = cities;
        if (this.cityIds && this.cityIds.length) {
          this.options = this.options.filter(r => this.cityIds?.includes(r.id));
        }
        if (this.default && (this.options ?? []).length === 1) {
          this.selected = this.options[0].id;
          this.onModelChanged(this.selected);
        }
      });
    }
  }
}
